<h1>Sign In</h1>

<div class="card">
  <form (ngSubmit)="signIn()" #signinForm="ngForm">
    <label for="email">Email</label>
    <input id="email" name="email" type="email" required [(ngModel)]="email" />

    <label for="password">Password</label>
    <input id="password" name="password" type="password" required [(ngModel)]="password" />

    <button type="submit" [disabled]="loading">{{ loading ? 'Signing in...' : 'Sign In' }}</button>

    <p class="error" *ngIf="authError">{{ authError }}</p>
    <p class="muted" *ngIf="authMessage">{{ authMessage }}</p>
    <p class="muted">Need an account? <a routerLink="/sign-up">Sign up</a></p>
  </form>
</div>

<div class="card" *ngIf="currentUser">
  <h2>Users CRUD (from users table)</h2>
  <p class="muted">Signed in as: {{ currentUser.email || 'Unknown user' }}</p>

  <button (click)="loadUsers()" [disabled]="usersLoading">
    {{ usersLoading ? 'Loading...' : 'Refresh Users' }}
  </button>

  <p class="error" *ngIf="usersError">{{ usersError }}</p>

  <h3 style="margin-top:20px;">Create User</h3>
  <div class="company-row" style="grid-template-columns: 1fr 1fr 1fr 1fr 1fr auto;">
    <input type="text" placeholder="First name" [(ngModel)]="newUserFirstName" name="new_user_first_name" />
    <input type="text" placeholder="Last name" [(ngModel)]="newUserLastName" name="new_user_last_name" />
    <input type="email" placeholder="Email" [(ngModel)]="newUserEmail" name="new_user_email" />
    <input type="text" placeholder="Phone" inputmode="tel" [(ngModel)]="newUserPhone" name="new_user_phone" />
    <input type="password" placeholder="Password" [(ngModel)]="newUserPassword" name="new_user_password" />
    <button type="button" (click)="createUser()">Create</button>
  </div>
  <p class="muted form-hint">Phone may include digits, spaces, parentheses, hyphens, and optional leading +. Password must be 8+ chars with upper, lower, number, and special character.</p>

  <h3 style="margin-top:20px;">User List</h3>
  <table *ngIf="users.length; else noUsers">
    <thead>
      <tr>
        <th>ID</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Created At</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td>{{ getUserId(user) ?? 'N/A' }}</td>
        <td>
          <span *ngIf="!isEditing(user)">{{ user.first_name || '—' }}</span>
          <input *ngIf="isEditing(user)" type="text" [(ngModel)]="editFirstName" name="edit_first_name_{{ getUserId(user) }}" />
        </td>
        <td>
          <span *ngIf="!isEditing(user)">{{ user.last_name || '—' }}</span>
          <input *ngIf="isEditing(user)" type="text" [(ngModel)]="editLastName" name="edit_last_name_{{ getUserId(user) }}" />
        </td>
        <td>
          <span *ngIf="!isEditing(user)">{{ user.email || '—' }}</span>
          <input *ngIf="isEditing(user)" type="email" [(ngModel)]="editEmail" name="edit_email_{{ getUserId(user) }}" />
        </td>
        <td>
          <span *ngIf="!isEditing(user)">{{ user.phone || '—' }}</span>
          <input *ngIf="isEditing(user)" type="text" inputmode="tel" [(ngModel)]="editPhone" name="edit_phone_{{ getUserId(user) }}" />
        </td>
        <td>{{ user.created_at ? (user.created_at | date:'medium') : '—' }}</td>
        <td>
          <div style="display:flex; gap:8px; flex-wrap:wrap;">
            <button *ngIf="!isEditing(user)" type="button" class="secondary" (click)="startEdit(user)">Edit</button>
            <button *ngIf="isEditing(user)" type="button" (click)="saveEdit()">Save</button>
            <button *ngIf="isEditing(user)" type="button" class="secondary" (click)="cancelEdit()">Cancel</button>
            <button type="button" class="ghost" (click)="deleteUser(user)">Delete</button>
          </div>
          <div *ngIf="isEditing(user)" style="margin-top:8px;">
            <input type="password" placeholder="New password (optional)" [(ngModel)]="editPassword" name="edit_password_{{ getUserId(user) }}" />
            <p class="muted form-hint">If set, password must be 8+ chars with upper, lower, number, and special character.</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #noUsers>
    <p class="muted">No users found.</p>
  </ng-template>
</div>
